import { UploadedFileResponseDtoStatusEnum } from 'libs/pinnacle-sdk';

export const SETTLE_SOV_FILE_STATUS: UploadedFileResponseDtoStatusEnum[] = [
  UploadedFileResponseDtoStatusEnum.Completed,
  UploadedFileResponseDtoStatusEnum.Failed,
];
